import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetArticleListActionType {
  Reset = 'articleList/resetArticleList',
}

export type TResetArticleList = ITypedReduxAction<EResetArticleListActionType.Reset>;
